import React from 'react'
import { Link } from 'react-router-dom'
import './AboutContent.css'
import ReactImg from '../assets/react1.jpg'
import ReactImg2 from '../assets/React2.webp'


const AboutContent = () => {
  return (
    <div className='about'>
        <div className="left">
            <h1>Who am I?</h1>
            <p>I am a FrontEnd Developer. I Create responsive secure websites </p>
            <Link to="/contact">
                <button className='btn'>
                    Contact
                </button>
            </Link>
        </div>

        <div className="right">
            <div className="image-container">
                <div className="img-stack top">
                    <img 
                        src={ReactImg} 
                        alt="reactimg"
                        className='img'
                    />
                </div>
                <div className="img-stack bottom">
                    <img 
                        src={ReactImg2} 
                        alt="reactimg"
                        className='img'
                    />
                </div>
            </div>
        </div>

    </div>
  )
}

export default AboutContent